import { render, staticRenderFns } from "./VehicleRequestTypeUserOrganisationCount.vue?vue&type=template&id=e2553734&"
import script from "./VehicleRequestTypeUserOrganisationCount.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestTypeUserOrganisationCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports